import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { HiArrowRight } from "react-icons/hi";

import { ThemeContext } from '../../contexts/ThemeContext';
import { projectsData } from '../../data/projectsData';
import SingleProject from './SingleProject/SingleProject';
import './Projects.css';

const useStyles = makeStyles(() => ({
    viewAllBtn: {
        color: ({ theme }) => theme.secondary,
        backgroundColor: ({ theme }) => theme.buttonColor,
        transition: 'all 0.5s ease-in-out',
        "&:hover": {
            color: ({ theme }) => theme.secondary,
            backgroundColor: ({ theme }) => theme.primary,
        }
    },
    viewArr: {
        color: ({ theme }) => theme.buttonColor,
        backgroundColor: ({ theme }) => theme.secondary,
        width: '40px',
        height: '40px',
        padding: '0.5rem',
        fontSize: '1.05rem',
        borderRadius: '50%',
        cursor: 'pointer',
        transition: 'background-color 0.5s',
        "&:hover": {
            color: ({ theme }) => theme.buttonColor,
            backgroundColor: ({ theme }) => theme.secondary,
        }
    },
}));

function Projects() {
    const { theme } = useContext(ThemeContext);
    const classes = useStyles({ theme });

    if (!projectsData || projectsData.length === 0) {
        return null;
    }

    return (
        <div className="projects" id="projects" style={{ backgroundColor: theme.secondary }}>
            <div className="projects--header">
                <h1 style={{ color: theme.primary }}>Projects</h1>
            </div>
            
            <div className="projects--body">
                <div className="projects--bodyContainer">
                    {projectsData.slice(0, 3).map((project) => {
                        const { id, projectName, projectDesc, tags, code, demo, image } = project;
                        
                        return (
                            <SingleProject
                                theme={theme}
                                key={id}
                                id={id}
                                name={projectName}
                                desc={projectDesc}
                                tags={tags}
                                code={code}
                                demo={demo}
                                image={image}
                            />
                        );
                    })}
                </div>

                {projectsData.length > 3 && (
                    <div className="projects--viewAll">
                        <Link to="/projects">
                            <button className={classes.viewAllBtn}>
                                View All
                                <HiArrowRight className={classes.viewArr} />
                            </button>
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Projects;